export const SET_AI_ANALYTICS_THREADS = 'SET_AI_ANALYTICS_THREADS';
export const SET_AI_ANALYTICS_ACTIVE_THREAD = 'SET_AI_ANALYTICS_ACTIVE_THREAD';
export const UPDATE_AI_ANALYTICS_THREAD = 'UPDATE_AI_ANALYTICS_THREAD';
export const ADD_AI_ANALYTICS_MESSAGE = 'ADD_AI_ANALYTICS_MESSAGE';
export const UPDATE_AI_ANALYTICS_MESSAGE = 'UPDATE_AI_ANALYTICS_MESSAGE';
export const SET_AI_ANALYTICS_PENDING_ASK = 'SET_AI_ANALYTICS_PENDING_ASK';
export const SET_AI_ANALYTICS_PENDING_OP = 'SET_AI_ANALYTICS_PENDING_OP';
export const DISMISS_AI_ANALYTICS_ASK_POPUP = 'DISMISS_AI_ANALYTICS_ASK_POPUP';
export const RESET_AI_ANALYTICS_ASK_POPUP_DISMISSALS = 'RESET_AI_ANALYTICS_ASK_POPUP_DISMISSALS';
export const ADD_AI_ANALYTICS_COMPLETED_ASK = 'ADD_AI_ANALYTICS_COMPLETED_ASK';
export const REMOVE_AI_ANALYTICS_COMPLETED_ASK = 'REMOVE_AI_ANALYTICS_COMPLETED_ASK';
export const CLEAR_AI_ANALYTICS_COMPLETED_ASKS = 'CLEAR_AI_ANALYTICS_COMPLETED_ASKS';
export const SET_AI_ANALYTICS_THREADS_LOADING = 'SET_AI_ANALYTICS_THREADS_LOADING';
export const SET_AI_INSTRUCTIONS_LOADING = 'SET_AI_INSTRUCTIONS_LOADING';
export const SET_AI_ANALYTICS_ERROR = 'SET_AI_ANALYTICS_ERROR';
export const ADD_SAVED_CHART = 'ADD_SAVED_CHART';
export const UPDATE_SAVED_CHART = 'UPDATE_SAVED_CHART';
export const REMOVE_SAVED_CHART = 'REMOVE_SAVED_CHART';
export const SET_SAVED_CHARTS = 'SET_SAVED_CHARTS';
export const SET_SELECTED_CHART = 'SET_SELECTED_CHART';
export const SET_INSTRUCTIONS = 'SET_INSTRUCTIONS';
export const ADD_INSTRUCTION = 'ADD_INSTRUCTION';
export const UPDATE_INSTRUCTION = 'UPDATE_INSTRUCTION';
export const REMOVE_INSTRUCTION = 'REMOVE_INSTRUCTION';
